import { Component, Input } from '@angular/core';
import { faBriefcase, faStar, faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'xqnr-category-icon',
    templateUrl: './category-icon.component.pug',
    styleUrls: ['./category-icon.component.scss'],
    standalone: false
})
export class CategoryIconComponent {
  @Input() icon: 'personal_attributes' | 'role_specific' | 'essential';
  @Input() fixedWidth = true;

  fa = {
    essential: faStar,
    personal_attributes: faUser,
    role_specific: faBriefcase,
  };

  colour = {
    essential: '#FF9F27',
    personal_attributes: '#219500',
    role_specific: '#A700F5',
  };
}
